interface GetDeepLink {
  hostname: string;
  query?: Record<string, string | string[] | undefined>;
}

const getDeepLink = ({ hostname, query }: GetDeepLink): string => {
  const parsedQuery = query
    ? Object.entries(query).reduce((value, current) => {
        const [currentKey, currentValue] = current;
        if (!currentValue) return value;
        if (Array.isArray(currentValue)) {
          return `${value}${
            value.length === 0 ? "" : "&"
          }${currentKey}=${currentValue.join(`&${currentKey}=`)}`;
        }
        return `${value}${
          value.length === 0 ? "" : "&"
        }${currentKey}=${currentValue}`;
      }, "")
    : "";

  return `otrium://${hostname}${parsedQuery ? `?${parsedQuery}` : ""}`;
};

export default getDeepLink;
